import Intro from './Intro';
import DebugGameIntro from './DebugGameIntro';
import DebugGame from './DebugGame';
import DebugGameOutro from './DebugGameOutro';
import DebugGame2Intro from './DebugGame2Intro';
import DebugGame2 from './DebugGame2';
import DebugGame2Outro from './DebugGame2Outro';

export default [Intro, DebugGameIntro, DebugGame, DebugGameOutro, DebugGame2Intro, DebugGame2, DebugGame2Outro];
